<!--
Copyright 2019 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <div id="project-edit" class="panel panel-simple">
    <div class="panel-heading">
      <h1 class="panel-title">{{ $t('title') }}</h1>
    </div>
    <div class="panel-body">
      <form @submit.prevent="submit">
        <form-group v-model.trim="name" :placeholder="$t('field.name')" required
          autocomplete="off"/>
        <button type="submit" class="btn btn-primary"
          :disabled="awaitingResponse">
          {{ $t('action.update') }} <spinner :state="awaitingResponse"/>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import FormGroup from '../form-group.vue';
import Spinner from '../spinner.vue';
import request from '../../mixins/request';
import { apiPaths } from '../../util/request';
import { noop } from '../../util/util';
import { requestData } from '../../store/modules/request';

export default {
  name: 'ProjectEdit',
  components: { FormGroup, Spinner },
  mixins: [request()],
  data() {
    return {
      awaitingResponse: false,
      name: this.$store.state.request.data.project.name
    };
  },
  computed: requestData(['project']),
  methods: {
    submit() {
      const { name } = this;
      this.patch(apiPaths.project(this.project.id), { name })
        .then(response => {
          this.$store.commit('setData', {
            key: 'project',
            // We do not simply specify response.data, because it does not
            // include extended metadata.
            value: this.project.with({
              name,
              updatedAt: response.data.updatedAt
            })
          });
          this.$alert().success(this.$t('alert.success'));
        })
        .catch(noop);
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is a title shown above a section of the page.
    "title": "Basic Details",
    "field": {
      "name": "Project name"
    },
    "action": {
      "update": "Save settings"
    },
    "alert": {
      "success": "Project settings saved!"
    }
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Základní detaily",
    "field": {
      "name": "Název projektu"
    },
    "action": {
      "update": "Uložit nastavení"
    },
    "alert": {
      "success": "Nastavení projektu uloženo."
    }
  },
  "de": {
    "title": "Basisinformationen",
    "field": {
      "name": "Projektname"
    },
    "action": {
      "update": "Einstellungen speichern"
    },
    "alert": {
      "success": "Projekteinstellungen wurden gespeichert"
    }
  },
  "es": {
    "title": "Detalles básicos",
    "field": {
      "name": "Nombre del proyecto"
    },
    "action": {
      "update": "Guardar la configuración"
    },
    "alert": {
      "success": "¡Configuración del proyecto guardada!"
    }
  },
  "fr": {
    "title": "Détails basiques",
    "field": {
      "name": "Nom du projet"
    },
    "action": {
      "update": "Enregistrer les paramètres"
    },
    "alert": {
      "success": "Paramètres du projet enregistrés !"
    }
  }
}
</i18n>
